import * as trackerInterface from '../interfaces/trackerInterface';
import { getLogger } from '../logger';
import events from './events';

const log = getLogger('tracker');

class Tracker {
  constructor(trackerInterfaceParam) {
    this.trackerInterface = trackerInterfaceParam;
    this.dynamicDefaultPropertiesCreator = trackerInterfaceParam.dynamicDefaultProperties
      ? trackerInterfaceParam.dynamicDefaultProperties
      : () => {}; // eslint-disable-line @typescript-eslint/no-empty-function
    this.events = events;
    this.dateLastActiveTracked = new Date(0);
    this.defaultProperties = {};
  }

  identify = (userId) => {
    this.userId = userId || 'unknown';
    this.trackerInterface.identify(this.userId);
    const userIdVerify = this.trackerInterface.getIdentity();
    if (!assert(userIdVerify === this.userId, `tracker failed to identify user '${this.userId}'`)) {
      this.userId = undefined;
    }
  };

  setDefaultProperties = (properties) => {
    this.defaultProperties = properties;
  };

  setUserId = (userId) => {
    this.userId = userId;
  };

  timeEvent = (event) => {
    this.trackerInterface.timeEvent(event);
  };

  track = (event, properties) => {
    try {
      if (this.userId) {
        const defaultProps = { ...this.defaultProperties, ...this.dynamicDefaultPropertiesCreator() };
        const allProperties = { ...defaultProps, ...properties };
        log.log('track: ', event, '\nexplicit props: ', properties, '\ndefault props:', defaultProps);
        this.trackerInterface.track(event, allProperties);
      } else {
        log.warn(`track: '${event}'\nreject to track unidentified user\ncall 'identify(<userId>)' first`);
      }
    } catch (e) {
      log.error(`tracking failed: ${e}`);
    }
  };

  trackActive(properties = {}) {
    const dateNow = new Date();
    if (dateNow - this.dateLastActiveTracked > 15 * 60 * 1000) {
      // once per 15 mins
      if (this.defaultProperties.qcs_id !== 'unknown') {
        this.track(this.events.active, properties);
        this.dateLastActiveTracked = dateNow;
      }
    }
  }

  resetActiveTimestamp() {
    this.dateLastActiveTracked = new Date(0);
  }

  updateProfile(props) {
    return this.trackerInterface.updateProfile(props);
  }
}

const gTracker = new Tracker(trackerInterface);

export { gTracker as default };
